export const CourseHome = {
    "考勤":"考勤",
    "表现":"表現",
    "成绩管理":"成績管理",
    "学情分析":"學情分析",
    "报名审核":"報名審核",
    "成绩":"成績",
    "学习分析":"學習分析",
    "错题集":"錯題集",
    "课堂正在上课":"課堂正在上課/直播...",
    "立即进入":"立即進入",
    "正在会议中":"正在會議中...",
    "个会议正在进行中":"個會議正在進行中…",
    "会议功能需要绑定邮箱后才能使用!":"會議功能需要綁定郵箱後才能使用!",
    "学习资料":"學習資料",
    "慕课资料":"慕課資料",
    "录屏录像":"錄屏錄像",
    "直播录像":"直播錄像",
    "课程内容":"課程內容",
    "加课码已停用":"加課碼已停用",
    "加课码已启用":"加課碼已啟用",
    "学生视角":"學生視角",
    "课堂评价":"課堂評價",
    "分组":"分組",
    "加课码":"加課碼",
    "已认证":"已認證",
    "成员":"成員",
    "已加课":"已加課",
    "课程介绍":"課程介紹",
    "个章节":"個章節",
    "个活动":"個活動",
    "该小节暂无内容":"該小節暫無內容",
    "该课程暂无章节":"該課程暫無章節",
    "正同步数据":"正同步數據",
    "检测到旧版课程数据向新版同步未完成":"檢測到舊版課程數據向新版同步未完成",
    "当前同步进度":"當前同步進度",
    "学习进度":"學習進度",
    "继续学习":"繼續學習",
    "当前进入学生视角":"當前進入學生視角，以學生身份體驗課程",
    "进行中":"進行中...",
    "最新":"最新",
    "目录":"目錄",
    "待完成":"待完成",
    "学时":"學時",
    "请完善以下信息":" 請完善以下信息",
    "班级":"班级",
    "请输入班级":"請輸入班級",
    "年级":"年级",
    "请选择年级":"請選擇年級",
    "入学时间":"入學時間",
    "请选择入学时间":"請選擇入學時間",
    "引用":"引用",
    "课堂已结束请对本次课堂进行评价":"課堂已結束！請對本次課堂進行評價（匿名）",
    "匿名提交评价":"匿名提交評價",
    "评价成功":"評價成功！",
    "被引用":"被引用",
    "次":"次",
    "已下载":"已下載",
    "引用到课程":"引用到課程",
    "慕课外链":"慕課外鏈",
    "邀请您进入课程":"邀請您進入課程",
    "输入加课码直达":"輸入加課碼直達",
    "评审":"評審",
    "截止":"截止:",
    "起止":"起止:",
    "试题":"試題:",
    "直播视频":"直播視頻",
    "录播视频":"錄播視頻",
    "互动视频":"互動視頻",
    "待学习":"待學習",
    "待参与":"待參與",
    "未提交":"未提交",
    "已提交":"已提交",
    "已批改":"已批改",
    "待批改":"待批改",
    "进入会议":"進入會議",
    "待开始":"待開始",
    "发布会议":"發布會議",
    "将于开始":"將於",
    "空开始":"開始",
    "未批":"未批",
    "已学完":"已學完",
    "创建时间":"創建時間:",
    "抢答":"搶答",
    "抢答成功":"搶答成功",
    "已有":"已有",
    "学年学期":"學年-學期",
    "授课地点":"授課地點",
    "授课模式":"授課模式",
    "全年":"全年",
    "上学期":"上學期",
    "下学期":"下學期",
    "请确认是否删除此":"請確認是否刪除此",
   "当前显示的教学活动模块":"當前顯示的教學活動模塊",
   "原":"（原",
   "更多模块":"更多模塊",
   "点击即可添加模块":"點擊即可添加模塊",
   "修改教学活动模块名":"修改教學活動模塊名",
   "结构化组织教学活动":"結構化組織教學活動",
   "上课课件":"上課課件",
   "老师分享资料":"老師分享資料",
   "投票问卷答题":"投票、問卷、答題",
   "报告或文档型作业":"報告或文檔型作業",
   "提供师生讨论功能":"提供師生討論功能",
   "阶段性测试考核":"階段性測試、考核",
   "通知公告等":"通知、公告等",
   "链接腾讯会议":"鏈接騰訊會議",
   "教学活动模块名称不能为空":"教學活動模塊名稱不能為空",
   "教学活动模块名称最多 8 个字":"教學活動模塊名稱最多 8 個字",
   "至少存在一个教学活动模块":"至少存在壹個教學活動模塊",
   "当前暂无可学习内容":"當前暫無可學習內容",
   "老师已经禁止学生发起话题":"老師已經禁止學生發起話題",
   "您有未完成的评教":"您有未完成的評教",
   "是否填写评教":"是否填寫評教",
   "去填写":"去填寫",
   "暂不填写":"暫不填寫",
   "开始评教":"開始評教",
   "题未作答请检查后提交":"題 未作答，請檢查後提交",
   "评教提交成功":"評教提交成功",
   "今日":"今日",
   "学生评价参与率":"學生評價參與率",
   "好评率":"好評率",
   "待改进":"待改進",
   "得分占比":"得分占比",
   "问题评价占比":"問題評價占比",
   "自定义日期":"自定義日期",
   "请输入":"請輸入",
   "提交成功等待审核":"提交成功，等待審核",
   "耐心等待老师审核如有疑问请与课程老师联络":"耐心等待老師審核，如有疑問，請與課程老師聯絡",
   "异议请联系课程负责人":"如對審核結果有異議，請聯絡課程負責人處理，無需撥打客服電話或聯絡平台客服。平台僅提供技術服務。",
   "课程负责人":"課程負責人",
   "负责人姓名":"姓名：{name}",
   "负责人单位":"單位：{school}",
   "私信课程负责人":"私信課程負責人",
   "有必填项未填":"有必填項未填",
   "未认证":"未認證",
   "重命名标签":"重命名標簽",
   "全选":"全選",
   "移出小组":"移出小组",
   "加入小组":"加入小组",
   "设为组长":"設為組長",
   "设为组长跳转":"设为组长跳转",
   "组数":"組數",
   "允许学生选组":"允許學生選組",
   "禁止":"禁止",
   "允许":"允許",
   "学生进组":"學生進組",
   "未分组学生":"未分組學生",
   "我加入的小组":"我加入的小組",
   "人数":"人數",
   "其他组":"其他组",
   "本分组内暂无小组":"本分組內暫無小組",
   "你可以":"妳可以",
   "建立第一个小组":"建立第壹個小組",
   "新建小组":"新建小組",
   "分组设置":"分組設置",
   "已删除":"已刪除",
   "设置成功":"設置成功",
   "设定组长":"設定組長",
   "设定组长成功":"設定組長成功",
   "分组标题":"分組標題",
   "请输入分组标题":"請輸入分組標題",
   "小组人数上限":"小組人數上限",
   "允许学生新建删除小组":"允許學生新建/刪除小組",
   "组数上限":"組數上限",
   "移除成功":"移除成功",
   "加入成功":"加入成功",
   "选择加入的小组":"選擇加入的小組",
   "添加成员":"添加成員",
   "加入该组":"加入該組",
   "退出该组":"退出該組",
   "移除组员":"移除組員",
   "编辑小组":"編輯小組",
   "删除小组":"刪除小組",
   "确定要删除小组":"確定要刪除小組",
   "已退出":"已退出",
   "已加入":"已加入",
   "移出成功":"移出成功",
   "添加组员":"添加組員",
   "暂无分组":"暫無分組",
   "固定组":"固定組",
   "自由组":"自由組",
   "限制组":"限制組",
   "已进组人数":"已進組人數",
   "未进组人数":"未進組人數",
   "新建分组":"新建分組",
   "小组名称":"小組名稱",
   "请输入小组名称":"請輸入小組名稱",
   "加入时间":"加入時間",
   "学生信息":"學生信息",
   "助教信息":"助教信息",
   "老师信息":"老師信息",
   "学生分组":"學生分組",
   "设置":"設置",
   "不允许退课":"不允許退課",
   "成员设置":"成員設置",
   "总览":"總覽",
   "松开发送":"松開發送",
   "按住讲话":"按住講話",
   "松开发送上滑取消":"松開 發送，上滑 取消",
   "取消发送语音":"取消發送語音",
   "老师已禁止发言":"老師已禁止發言!",
   "条":"條",
   "按时间":"按時間",
   "课堂对象全部成员":"課堂對象：全部成員",
   "上课人数":"上課人數",
   "上课时长":"上課時長",
   "提问":"提問",
   "口头回答":"口頭回答",
   "手机抢答":"手機搶答",
   "查看详情":"查看詳情",
   "关闭弹幕":"關閉彈幕",
   "弹幕数":"彈幕數",
   "日":"日",
   "暂无课堂记录":"暫無課堂記錄",
   "话题参与率":"話題參與率",
   "互动参与率":"互動參與率",
   "出勤率":"出勤率",
   "表现星星数":"表現星星數",
   "作业提交率":"作業提交率",
   "班级平均":"班級平均",
   "学生个人":"學生個人",
   "发布数":"發布數",
   "回答数":"回答數",
   "学习人数":"學習人數",
   "标签":"標簽",
   "固定小组":"固定小組",
   "活动分组":"活動分組",
   "整体完成率":"整體完成率",
   "作业提交":"作業提交",
   "资料学习":"資料學習",
   "测试提交":"測試提交",
   "本周":"本周",
   "本月":"本月",
   "课堂互动次数":"課堂互動次數",
   "作业发布次数":"作業發布次數",
   "测试发布次数":"測試發布次數",
   "话题回复数":"話題回復數",
   "互动课件发布次数":"互動課件發布次數",
   "资料发布次数":"資料發布次數",
   "资料互动课件发布次数":"資料/互動課件發布次數",
   "弹幕条数":"彈幕條數",
   "课堂互动":"課堂互動",
   "累计发布抢答条数":"累計發布搶答條數",
   "参与抢答人数":"參與搶答人數",
   "抢答平均参与率":"搶答平均參與率",
   "累计发布提问次数":"累計發布提問次數",
   "累计随机提问次数":"累計隨機提問次數",
   "累计点名提问次数":"累計點名提問次數",
   "累计发布个数":"累計發布個數",
   "答题总数":"答題總數",
   "平均参与率":"平均參與率",
   "平均正确率":"平均正確率",
   "互动答题榜":"互動答題榜",
   "正确率":"正確率",
   "参与率":"參與率",
   "抢答榜":"搶答榜",
   "成功次数":"成功次數",
   "表现榜":"表現榜",
   "累计星星数":"累計星星數",
   "累计发布次数":"累計發布次數",
   "提交作业份数":"提交作業份數",
   "作业平均分":"作業平均分",
   "作业提交人数":"作業提交人數",
   "准时提交率":"準時提交率",
   "测试平均分":"測試平均分",
   "累计参与测试人数":"累計參與測試人數",
   "测试提交率":"測試提交率",
   "累计话题发布数":"累計話題發布數",
   "累计话题回复数":"累計話題回復數",
   "累计点赞数":"累計點贊數",
   "话题精华率":"話題精華率",
   "成员参与率":"成員參與率",
   "资料类型":"資料類型",
   "资料互动课件":"資料/互動課件",
   "平均学习进度":"平均學習進度",
   "整体分析":"整體分析",
   "学生分析":"學生分析",
   "开始上课":"開始上課",
   "下课":"下課",
   "创建人":"創建人",
   "提交":"提交",
}
